

/**
 * Shows an alert if the user has not yet confirmed their email address.
 *
 * @param {import('../ForumApplication').default} app
 */
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import BindRoleModal from './BindRoleModal';
export default {

  onSuccess(app, text) {
    app.alerts.show({ type: 'success', dismissible: false, className:'alertClass' }, text)
    setTimeout(function() {
      app.alerts.clear();
    }, 3000);
  },

  onWarn(app, text) {
    app.alerts.show({ type: 'warn', dismissible: false, className:'alertClass' }, text)
    setTimeout(function() {
      app.alerts.clear();
    }, 3000);
  },

  onError(app, text) {
    app.alerts.show({ type: 'error', dismissible: false, className:'alertClass' }, text)
    setTimeout(function() {
      app.alerts.clear();
    }, 3000);
  },

  isPermanentSuspensionDate(date) {
    dayjs.extend(utc);
    return dayjs.utc(date).isSame(dayjs.utc('2038-01-01'));
  },

  checkUsername(username) {
    const regex = /^[a-zA-Z][0-9a-zA-Z_]{5,16}$/;
    if (!regex.test(username) || username.length < 6 || username.length > 32) {
      return false;
    }
    return true;
  },

  checkEmail(email) {
    const regex =  /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!regex.test(email)) {
      return false;
    }
    return true;
  },

  checkPwd(pwd) {
    if (pwd.length < 6 || pwd.length > 32) {
      return false;
    }
    return true;
  },

  checkCode(code) {
    const regex =  /^\d{6}$/;
    if (!regex.test(code)) {
      return false;
    }
    return true;
  },

  //获取角色信息
  getRoleInfo(app) {
    if (app.session.user) {
      app.request({
        method: 'GET',
        url: app.forum.attribute('apiUrl') + '/sdkUserRole/' + app.session.user.id(),
      }).then(res=>{
        app.data['roleInfo'] = res;

        Object.keys(res).map((key) => {
          if (res[key].length === 0) return
          res[key].map((element) => {
            // let roleInfo = {rid: element.rid, lev: element.lev, srvId: element.srvId, name: element.name, faceId: element.faceId, pkgId: element.pkgId, pkgName: element.pkgName}
            // app.data['roleInfo'].push(roleInfo)
            if(element.current){
              app.data['currentRole'] = element;
            }
          })
        })

        // 判断是否绑定角色，未绑定则弹出绑定弹窗
        if (app.data['currentRole'] === undefined && (app.data.pkgLogo.ossFile === 'storm' || app.data.pkgLogo.ossFile === 'epicroute')) {
          app.modal.show(BindRoleModal,{},true);
        }
      })
    }
    
    return null;
  },

  copyToClipboar(text){
    if (navigator.clipboard) { // 现代浏览器支持
      navigator.clipboard.writeText(text).then(() =>{
        this.onSuccess(app, app.translator.trans('dl-person.forum.copy_success'));
        // alert('内容已复制到剪贴板3');
      }).catch(err => {
        console.error('无法复制文本: ', err);
      });
    } else { // 兼容旧浏览器
      const textArea = document.createElement("textarea");
      textArea.value = text;
      // 设置 textarea 的样式，使其不可见
      textArea.style.position = 'absolute';
      textArea.style.left = '-9999px';
      textArea.style.top = '-9999px';
      // 设置 readonly 属性
      textArea.setAttribute('readonly', '');
      document.body.appendChild(textArea);
      textArea.select();
      try {
        document.execCommand('copy');
        this.onSuccess(app, app.translator.trans('dl-person.forum.copy_success'));
        // alert('内容已复制到剪贴板4');
      } catch (err) {
        console.error('无法复制文本: ', err);
      }
      document.body.removeChild(textArea);
    }
  },

}
